<template>
    <v-layout justify-center>
        <v-responsive max-width="1280px" width="100%">
            <list-heading v-model="showSearch" title="프로그램 목록">
                <v-btn-toggle slot="buttons" v-model="filter.hall" tile dense color="secondary">
                    <v-btn :value="null">전체</v-btn>
                    <v-btn value="A">Auction</v-btn>
                    <!-- <v-btn value="C">(구) Live Auction</v-btn> -->
                    <v-btn value="B">Special Sale Online</v-btn>
                </v-btn-toggle>
            </list-heading>
            <!-- <program-list-search v-model="filter" :showSearch="showSearch" @search="manualSearch" /> -->
            <v-data-table :items="items" :headers="headers" hide-default-footer disable-sort class="my-4">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <div slot="item.thumb" slot-scope="{ value }" class="py-4">
                    <image-popup :src="value?.url" size="48" />
                </div>
                <template v-slot:[`item.actions`]="{ item }">
                    <program-view :value="item" @input="update">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text icon color="primary" large><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                    </program-view>
                    <v-btn icon text color="red" @click="remove(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="my-4" @input="search()" />
            <program-view @input="update">
                <template #activator="{ attrs, on }">
                    <v-btn v-bind="attrs" v-on="on" fab fixed right bottom color="primary" large><v-icon>mdi-pencil</v-icon></v-btn>
                </template>
            </program-view>
        </v-responsive>
    </v-layout>
</template>

<script>
import ImagePopup from "@/components/console/dumb/image-popup.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import ProgramView from "@/components/console/auction/program-view.vue";
// import ProgramListSearch from "@/components/console/auction/program-list-search.vue";

import api from "@/api";
import { AUCTION_PROGRAM_HALLS } from "@/assets/variables";

const formatter_dateTime = (value) => value?.toDateTime?.() || "-";

const headers = [
    { text: "번호", value: "index", width: 70 },
    { text: "분류", value: "hall", width: 110, formatter: (value) => Object.values(AUCTION_PROGRAM_HALLS).find((hall) => hall.value == value)?.text },
    { text: "썸네일", value: "thumb", width: 80 },
    { text: "작품수", value: "_works.length", width: 80, formatter: (value) => `${value} 개` },
    { text: "제목", value: "subject" },
    { text: "위치", value: "location", width: 110 },
    { text: "일시", value: "at", width: 110, formatter: formatter_dateTime },
    { text: "시작일", value: "duration.startsAt", width: 110, formatter: formatter_dateTime },
    { text: "종료일", value: "duration.endsAt", width: 110, formatter: formatter_dateTime },
    { text: "작성일", value: "createdAt", width: 110, formatter: formatter_dateTime },
    { text: "", value: "actions", width: 140, align: "right" },
];

export default {
    components: {
        ImagePopup,
        ListHeading,
        ProgramView,
        // ProgramListSearch,
    },
    data() {
        return {
            ///////////////////////////////////////////////
            // 검색필터
            ///////////////////////////////////////////////
            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                hall: this.$route.query.hall || null,
            },

            page: +this.$route.query.page || 1,
            totalCount: 0,
            limit: 10,

            programs: [],
            headers,
        };
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit);
        },
        items() {
            return (this.programs || []).map((item, index) => ({ ...item, index: +this.totalCount - (+this.page - 1) * +this.limit - index }));
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        $route() {
            this.search(false);

            Object.assign(this.filter, this.$route.query);
            this.page = +this.$route.query.page || 1;
        },
        "filter.hall"() {
            this.page = 1;
            this.search(true);
        },
    },
    methods: {
        init() {
            this.search(false);
        },
        manualSearch() {
            this.page = 1;
            this.search();
        },
        async search(routable = true) {
            if (routable) this.$router.push({ query: Object.assign({}, this.filter, { page: this.page }) });

            var {
                summary: { totalCount },
                programs,
            } = await api.console.auction.programs.gets({
                headers: { skip: (this.page - 1) * this.limit, limit: this.limit },
                params: this.filter,
            });

            this.programs = programs;
            this.totalCount = totalCount;
        },
        async remove(item) {
            if (!confirm(`프로그램을 삭제하시겠습니까?\n\n제목:    "${item?.subject || ""}"\n작성일: ${item?.createdAt?.toDateTime()}`)) return;

            await api.console.auction.programs.delete(item);
            this.programs = this.programs.filter((content) => content._id !== item._id);
            alert("프로그램이 삭제되었습니다.");
        },
        async update(item) {
            const index = this.programs.findIndex(({ _id }) => _id == item._id);
            if (index > -1) this.programs.splice(index, 1, item);
            else {
                this.programs = [item, ...this.programs];
                this.totalCount += 1;
            }
        },
    },
};
</script>
